@if (config && !config.showLoader) {
    <div class="container" [class.clickable]="!invalidConfig" (click)="openWorkspace()">
        @if (invalidConfig) {
            <div class="error-message">{{ 'moduleDetailWidget.invalidConfigMessage' | t }}</div>
        } @else {
            @if (customTitle) {
                <div class="header">{{ customTitle }}</div>
            } @else {
                @let incidentItemName = 'moduleDetailWidget.incidentItemName' | t;
                <div class="header">
                    {{
                        'moduleDetailWidget.countOfLabel'
                            | t: { item: isIncidentItem ? incidentItemName : itemName }
                    }}
                </div>
                @if (usesAllIncidentsPreset) {
                    <div class="subtitle">
                        ({{ 'moduleDetailWidget.allIncidentsPreset' | t }})
                    </div>
                } @else if (presetName) {
                    <div class="subtitle">({{ presetName }})</div>
                }
            }
            <div class="count">{{ count }}</div>
        }
    </div>
}
